import {Component,ElementRef,ViewChild,} from "@angular/core";
import { FormBuilder, FormGroup, AbstractControl, ValidationErrors, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Utils } from "../../../../../shared/utils/Utils";
import { Ruta, RutasService } from "../../../../../shared/services/ruta.service";
import { DataService } from "../../../../../shared/services/municipios.service";
declare var require;
const Swal = require("sweetalert2");

export function noEspaciosValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  return value.trim().length === 0 ? { noEspacios: true } : null;
}
@Component({
  selector: 'app-listado-rutas',
  templateUrl: './listado-rutas.component.html',
  styleUrls: ['./listado-rutas.component.scss']
})

export class ListadoRutasComponent {
 

  @ViewChild("inputOrigen") inputOrigen!: ElementRef;

  pageSize1: number = 5; 
  page1: number = 1;
  totalItems: number;
  editMode: boolean;
  formMarca: FormGroup;
  rutas: Ruta[] = [];
  rutaForm!: FormGroup;
  rutaSeleccionada: any;

  nombreRuta: string = '';
  municipios: any[];
  public searchText: string = "";
  filteredTableItems: Ruta[];
  origenSeleccionado: number | null = null;
destinoSeleccionado: number | null = null;



  constructor(
    private rutasService: RutasService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private dataService: DataService,
  ) { }

  ngOnInit() {
    this.listarRutas();
    this.cargarMunicipios();

    this.rutaForm = this.fb.group({
      id: [''],
      origen: [null, [Validators.required]],
      destino: [null, [Validators.required]],
      nombre: [null, [Validators.required, noEspaciosValidator]],
      ruta: [null, [Validators.required, noEspaciosValidator]],
      estado: ['1', [Validators.required]],
    });
  }

  listarRutas(): void {
    this.rutasService.getRutas().subscribe({
      next: (data) => {
        this.rutas = data;
        if (!data.length) console.warn('🚫 No hay rutas registradas.');
        this.filteredTableItems = this.rutas; // ✅ Inicializa la tabla filtrada
      },
      error: (err) => console.error("❌ Error cargando rutas:", err),
    });
  }

  cargarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => this.municipios = data,
      error: (err) => console.error("❌ Error al obtener municipios:", err),
    });
  }

openModal(content: any, id?: number): void {
  if (id) {
    this.editMode = true; // Editar ruta

    this.rutasService.getRutaById(id).subscribe({
      next: (rutaData) => {
        this.rutaSeleccionada = rutaData;

        // Asegurarse que los valores de IDMUN sean tipo número
        const origenId = Number(rutaData.origen);
        const destinoId = Number(rutaData.destino);

        this.origenSeleccionado = origenId;
        this.destinoSeleccionado = destinoId;

        // Asignar valores al formulario
        this.rutaForm.patchValue({
          ...rutaData,
          origen: origenId,
          destino: destinoId
        });

        // Actualizar automáticamente el campo "nombre"
        this.actualizarNombreRuta();

        // Abrir modal
        this.modalService.open(content, { size: "xl", backdrop: "static" });
      },
      error: () => {
        Swal.fire({
          icon: "error",
          title: "No encontrada",
          text: `No se encontró una ruta con ID ${id}.`,
        });
      },
    });
  } else {
  this.editMode = false; // Crear ruta
  this.rutaSeleccionada = null;
  this.origenSeleccionado = null; // Limpiar selección previa
  this.destinoSeleccionado = null; // Limpiar selección previa

  this.rutaForm.reset({ estado: true });
  this.modalService.open(content, { size: "xl", backdrop: "static" });
}
}


  guardarRuta(): void {
    if (this.rutaForm.invalid) {
      this.mostrarAlerta("Campo requerido", "Por favor, complete todos los campos correctamente.", "info");
      this.rutaForm.markAllAsTouched();
      this.inputOrigen?.nativeElement.focus(); // Foco solo si es necesario
      return;
    }

    const datosRuta = {
      ...this.rutaForm.value,
      usuario: "admin",
    };

    const esEdicion = this.editMode && this.rutaSeleccionada;

    if (esEdicion) {
      const sinCambios = JSON.stringify(this.rutaSeleccionada) === JSON.stringify(datosRuta);

      if (sinCambios) {
        this.mostrarAlerta("Sin cambios", "No se han realizado modificaciones en la ruta.", "info");
        return;
      }

      this.rutasService.updateRuta(this.rutaSeleccionada.id, datosRuta).subscribe({
        next: () => {
          this.mostrarExito("Actualización exitosa", "Ruta actualizada correctamente.");
          this.finalizarGuardado();
        },
        error: (err) => this.mostrarError(err, "Error al actualizar la ruta"),
      });
    } else {
      this.rutasService.createRuta(datosRuta).subscribe({
        next: () => {
          this.mostrarExito("Guardado exitoso", "Ruta creada correctamente.");
          this.rutaForm.reset({ estado: true });
          this.finalizarGuardado();
        },
        error: (err) => this.mostrarError(err, "Error al guardar la ruta"),
      });
    }
  }

  private finalizarGuardado(): void {
    this.cerrarModalYRecargar();
  }

  buscarMunicipio(nombre: string): string | null {
    return this.municipios.find(m => m.MUNICIPIO.toLowerCase() === nombre?.toLowerCase())?.MUNICIPIO || null;
  }

  abrirModal(content: any): void {
    this.modalService.open(content, { size: "xl", backdrop: "static" });
  }

  mostrarAlerta(titulo: string, mensaje: string, tipo: any): void {
    Swal.fire({ icon: tipo, title: titulo, text: mensaje });
  }

  mostrarExito(titulo: string, mensaje: string): void {
    Swal.fire({ icon: "success", title: titulo, text: mensaje });
    this.cerrarModalYRecargar();
  }

  private cerrarModalYRecargar() {
    this.modalService.dismissAll(); // Cierra el modal
    this.listarRutas(); // Recarga las tarjetas para la placa actual
  }

  private mostrarError(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  actualizarEstadoRutaAInactivo(id: any) {
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar la ruta: ${id}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.rutasService.inactivarRuta(id).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "¡Ruta inactivada!",
              confirmButtonText: "Aceptar",
            });

            // Actualizar estado localmente (si lo haces en memoria)
            // ruta.estado = 0;

            // Recargar tabla y cerrar modal si aplica
            this.cerrarModalYRecargar();

            console.log("Rutas actualizadas:", this.rutas);
          },
          error: (error) => {
            const mensaje =
              error?.error?.message || "No se pudo actualizar el estado de la ruta";

            Swal.fire({
              icon: "error",
              title: "Error",
              text: mensaje,
              confirmButtonText: "Aceptar",
            });

            console.error("Error al inactivar ruta:", error);
          },
        });
      }
    });
  }

  exportToPDF(tableId:string,nameFile:string,titleFile:string) {
    Utils.exportToPDF(tableId, nameFile,titleFile);
  }
  
  exportarExcel(tableId:string,nameFile:string) {
      Utils.exportVisibleTableToExcel(tableId, nameFile);
  }
  
  ngOnDestroy() {
  }

  filterData() {
    const search = this.searchText.trim().toLowerCase();

    if (!search) {
      this.filteredTableItems = [...this.rutas]; // Mostrar todos si no hay búsqueda
    } else {
      this.filteredTableItems = this.rutas.filter((item) => {
        return (
          item.nombre?.toLowerCase().includes(search) ||
          item.ruta?.toLowerCase().includes(search) 

        );
      });
    }

    this.page1 = 1; // Reiniciar a la primera página
  }
  
actualizarNombreRuta(): void {
  const origenId = this.rutaForm.get('origen')?.value;
  const destinoId = this.rutaForm.get('destino')?.value;

  const origenNombre = this.municipios.find(m => m.IDMUN === origenId)?.MUNICIPIO || '';
  const destinoNombre = this.municipios.find(m => m.IDMUN === destinoId)?.MUNICIPIO || '';

  if (origenNombre && destinoNombre) {
    this.rutaForm.patchValue({ nombre: `${origenNombre} - ${destinoNombre}` });
  } else {
    this.rutaForm.patchValue({ nombre: '' });
  }
}



}